<template>
  <div class="info">
    <lb-table
      border
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '用户ID', prop: 'uid', minWidth: '120' },
        { label: '用户昵称', prop: 'nickName', minWidth: '220' },
        { label: '手机号码', prop: 'phone', minWidth: '120' },
        { label: '用户等级', prop: 'vipLabel', minWidth: '120' },
        { label: '邀请时间', prop: 'createTime', minWidth: '120' },
        {
          label: '累计贡献收益', prop: 'totalCommission', minWidth: '120',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.totalCommission).toFixed(2)}</div>
            )
          }
        }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: false
    }
  },
  watch: {
    phone (val, vall) {
      this.phone = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        phone: this.phone,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.matrixServerGetFansList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

